import React, { useState, useEffect, Fragment } from "react";

import LeftSideNavigation from "../../navigationSection/LeftSideNavigation";

import PropTypes from "prop-types";
import { connect } from "react-redux";

import { razor_pay_create_order } from "../../../../store/actions/OrderingAction/vendorOrderingAction";
import { ORDER_RAZORPAY_KEY } from "../../../../config/Keys";

const Payment = (props) => {
  //state

  function loadScript(src) {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  }

  const __DEV__ = document.domain === "localhost";

  const [name, setName] = useState("Mehul");

  async function displayRazorpay() {
    const res = await loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );

    if (!res) {
      alert("Razorpay SDK failed to load. Are you online?");
      return;
    }

    const onSuccess = (data) => {
      const options = {
        key: ORDER_RAZORPAY_KEY,
        currency: data.currency,
        amount: data.amount.toString(),
        order_id: data.id,
        name: "Donation",
        description: "Thank you for nothing. Please give us some money",
        //image: "http://localhost:1337/logo.svg",
        handler: function (response) {
          alert(response.razorpay_payment_id);
          alert(response.razorpay_order_id);
          alert(response.razorpay_signature);
        },
        prefill: {
          name,
          email: "",
          phone_number: "",
        },
      };
      const paymentObject = new window.Razorpay(options);
      paymentObject.open();
    };

    const formData = {
      amount: 20,
      user_id: "6030c5f597d0e4551b7b9891",
      refModel: "User",
      message: "Testing payment",
      currency: "INR",
      isEvent: false,
    };
    const token = props.auth.user.accessToken;
    props.razor_pay_create_order(token, formData, onSuccess);

    // const data = await fetch("http://localhost:1337/razorpay", {
    //   method: "POST",
    // }).then((t) => t.json());

    // console.log(data);
  }

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation />
          </div>
          <div className="super-admin-right-side-panel">
            <h1>PAYMENT</h1>
            <div className="App">
              <header className="App-header">
                {/* <img src={logo} className="App-logo" alt="logo" /> */}
                <p>
                  Edit <code>src/App.js</code> and save to reload.
                </p>
                <a
                  className="App-link"
                  onClick={displayRazorpay}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Donate $5
                </a>
              </header>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

Payment.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {
  razor_pay_create_order,
})(Payment);
